<template>
  <main class="page gallery-page">
    <div class="gallery-page__container">
      <ul class="breadcrumbs">
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'home'}">Главная</router-link>
        </li>
        <li class="breadcrumbs__item">
          <span>Учреждения</span>
        </li>
      </ul>
      <h1 class="gallery-page__title">Учреждения</h1>
      <ul class="gallery-page__items" v-if="$store.state.institutions">
        <li class="gallery-page__item" v-for="(institute, index) in $store.state.institutions" :key="index">
          <a v-if="institute.get_info" :href="'//' + institute.url" target="_blank" rel="nofollow" class="gallery" :title='institute.get_info.nameSchool' :aria-label='institute.get_info.nameSchool'>
            <img class="gallery__image" :src="institute.get_info | findSourceSchool($store.state.api)" @error="error" :alt='institute.get_info.nameSchool'/>
            <h3 class="gallery__title">{{ institute.get_info.nameSchool }}</h3>
            <span class="gallery__date">{{ institute.get_info.addressSchool }}</span>
          </a>
          <a v-else :href="'//' + institute.url" target="_blank" rel="nofollow" class="gallery">
            <img class="gallery__image" src="/public/img/gallery-placeholder.svg"/>
            <h3 class="gallery__title">{{ institute.url }}</h3>
          </a>
        </li>
      </ul>
    </div>
  </main>
</template>

<script>
export default {
  async asyncData ({ store }) {
    await store.dispatch('INSTITUTIONS_PAGE')
  },
  name: 'InstitutionsPage',
  methods: {
    error (e) {
      if (e.target.src !== '/public/img/gallery-placeholder.svg') e.target.src = '/public/img/gallery-placeholder.svg'
    }
  },
  metaInfo () {
    return this.$seo(
      'common',
      'Учреждения',
      'управление образования, образование',
      '',
      'Учреждения',
      '',
      ''
    )
  }
}
</script>
